module.exports = __webpack_public_path__ + "static/img/9.3506bb6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/5/sp/9.png
// module id = 7+nd
// module chunks = 0